import React, { type ComponentProps, type FC } from 'react';
import { ElementFactory, Question, Serializer } from 'survey-core';
import { ReactQuestionFactory } from 'survey-react-ui';

import IsInformationAccurate from '../../components/isInformationAccurate';

const IS_INFORMATION_ACCURATE_TYPE = 'is-information-accurate';

export class IsInformationAccurateModel extends Question {
  getType() {
    return IS_INFORMATION_ACCURATE_TYPE;
  }
}

export const bootIsInformationAccurateQuestion = () => {
  // Add question type metadata for further serialization into JSON
  Serializer.addClass(
    IS_INFORMATION_ACCURATE_TYPE,
    [],
    () => {
      return new IsInformationAccurateModel('');
    },
    'question',
  );

  ElementFactory.Instance.registerElement(
    IS_INFORMATION_ACCURATE_TYPE,
    (name) => {
      return new IsInformationAccurateModel(name);
    },
  );

  ReactQuestionFactory.Instance.registerQuestion(
    IS_INFORMATION_ACCURATE_TYPE,
    (props) => {
      return React.createElement<ComponentProps<any>>(
        IsInformationAccurate as FC,
        props,
      );
    },
  );
};
